import http from '@/utils/services/http'

export default {
  getEmails (limit, page, filtros) {
    let url = '/api/contato/?page=' + page + '&limit=' + limit + filtros
    return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  showEmail (id) {
    return http.get('/api/contato/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteEmail (id) {
    return http.patch('/api/contato/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  /* deleteEmail (id) {
    return http.delete('/api/contato/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  } */
  contestEmail (id, mailresponse) {
    return http.post('/api/contato/' + id + '/response', JSON.stringify({mensagem: mailresponse.mensagem, email: mailresponse.email}))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  sendNewEmail (mail) {
    return http.post('/api/contato/sendmail', JSON.stringify({mensagem: mail.mensagem, assunto: mail.assunto, destinatario: mail.destinatario}))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  setLido (id) {
    return http.patch('/api/contato/' + id + '/lido')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/contato/service/contato.js